var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
var ResetPasswordComponent = /** @class */ (function () {
    function ResetPasswordComponent(util, apiService) {
        this.util = util;
        this.apiService = apiService;
        this.submitted = false;
        this.username = "";
    }
    ResetPasswordComponent.prototype.ngOnInit = function () {
    };
    ResetPasswordComponent.prototype.checkUsername = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, user, req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!(this.username.trim() != "")) return [3 /*break*/, 7];
                        this.util.ShowWaiting(true);
                        this.submitted = false;
                        para = "username=" + this.username;
                        return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", para)];
                    case 1:
                        user = _a.sent();
                        if (!(user != null && user.length > 0)) return [3 /*break*/, 5];
                        if (!(user[0].dpa_customwebuserid != null && user[0].dpa_customwebuserid.toString().trim().length != 0)) return [3 /*break*/, 3];
                        req = {
                            username: this.username,
                            email: user[0].dpa_emailaddress,
                            call_by: "1",
                            url: this.util.baseUrl(),
                            userid: user[0].dpa_customwebuserid
                        };
                        return [4 /*yield*/, this.apiService.postCustom("Crm", "ResetCallCenterPassword", req)];
                    case 2:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            // let emailRes: any = await this.SendEmail(res, user[0].dpa_emailaddress)
                            // if (this.util.isSuccessResponse(emailRes)) {
                            this.util.SuccessDialog("ระบบได้ส่ง email สำหรับกำหนดรหัสผ่านใหม่ไปยัง email ของท่านแล้ว");
                            // }
                            // else {
                            //   this.util.ErrorDialog("ส่ง email กำหนดรหัสผ่านใหม่ไม่สำเร็จ กรุณาติดต่อเจ้าหน้าที่")
                            // }
                        }
                        else {
                            this.util.ErrorDialog("ไม่สามารถส่ง email กำหนดรหัสผ่านใหม่ได้ กรุณาติดต่อเจ้าหน้าที่");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ErrorDialog("ไม่พบ email ของ user ที่ท่านกรอก");
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.util.ErrorDialog("ไม่พบ user ที่ท่านกรอก");
                        _a.label = 6;
                    case 6:
                        this.util.ShowWaiting(false);
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // async SendEmail(token: any, email: string) {
    //   let MailObj: any = {
    //     dpa_name: "ท่านได้ร้องขอการกำหนดรหัสผ่านใหม่",
    //     dpa_emailaddress: email
    //   };
    //   let url = this.util.baseUrl() + "/setNewPassword?id=" + token
    //   var MailContent = "   โปรดคลิกลิงค์ด้านล่างเพื่อกำหนดรหัสผ่านใหม่ <br /><br />" +
    //     '<a target="_blank" href="' + url + '">' + url + "</a><br /><br />" +
    //     "ขอแสดงความนับถือ <br />" +
    //     "สถาบันคุ้มครองเงินฝาก <br />" +
    //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
    //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
    //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
    //     "โทร : 02-272-0300";
    //   MailObj.dpa_description = MailContent;
    //   MailObj.dpa_callby = 1
    //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
    //   return Res;
    // }
    ResetPasswordComponent.prototype.close = function () {
        window.close();
    };
    return ResetPasswordComponent;
}());
export { ResetPasswordComponent };



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts.pre-build-optimizer.js